import { TrashIcon } from "@heroicons/react/outline";
import { Trans } from "next-i18next";
import Image from "next/image";

import { Text } from "@/features/common/components/tailwind/Text";
import {
  SubscriptionPlanFullFragment,
  SubscriptionPlanStatusEnum,
} from "@/generated/generated-hooks";

type SubscriptionPlanCardImageProps = {
  subscriptionPlan: SubscriptionPlanFullFragment;
};

export function SubscriptionPlanCardImage({
  subscriptionPlan,
}: SubscriptionPlanCardImageProps) {
  const { image, title, subscriptionPlanStatus } = subscriptionPlan;
  const isRemoved =
    subscriptionPlanStatus === SubscriptionPlanStatusEnum.Removed;

  return (
    <div className="relative h-230">
      {isRemoved && (
        <div className="h-full flex flex-col items-center justify-center text-white bg-black/60 backdrop-blur-sm">
          <TrashIcon width={40} height={40} />
          <Text size="large">
            <Trans i18nKey={"subscriptionPlan:deletedPlan"} />
          </Text>
        </div>
      )}
      {!image ? null : (
        <Image
          src={image.url}
          alt={title}
          layout="fill"
          objectFit="cover"
          objectPosition="center"
          className="-z-10"
        />
      )}
    </div>
  );
}
